import { SEEDSPECIES_COLLECTION } from 'constants/gcConstants';
import { M_CROPS_QUERY_KEY } from 'constants/queryKeys';
import { MSeedSpecies } from 'interfaces/IMasterDb';
import { useFetchMCollection } from 'hooks/useFetchMCollection';

export const useFetchMSeedSpecies = (mOrgId: string | null) =>
  useFetchMCollection<MSeedSpecies>(SEEDSPECIES_COLLECTION, mOrgId, [
    M_CROPS_QUERY_KEY,
  ]);
